import { createContext, Dispatch, ReactNode, SetStateAction } from "react";
import { LoginModalMode } from "./types/LoginModalMode";

export type LoginModalContextState = {
  setShowModal(value: boolean): void;
  setDefaultEmailAddress?: (value: string) => void;
  setDefaultFirstName?: (value: string) => void;
  setDefaultLastName?: (value: string) => void;
  modeState: [LoginModalMode, Dispatch<SetStateAction<LoginModalMode>>];
  validateEmailFn?: (email: string) => Promise<boolean>;
  setValidateEmailFn?: Dispatch<
    SetStateAction<((email: string) => Promise<boolean>) | undefined>
  >;
  emailFeedback?: ReactNode;
  setEmailFeedback?: (feedback: ReactNode) => void;
};

const LoginModalContext = createContext<LoginModalContextState>(
  {} as LoginModalContextState
);

export default LoginModalContext;
